export default __webpack_public_path__ + "static/media/logo-icon.f70d86f6.png";